import { Button } from '../../components/Button';

interface AuthModeToggleProps {
  isSignup: boolean;
  onToggle: () => void;
}

/**
 * Toggle component to switch between login and signup modes.
 */
export const AuthModeToggle = ({ isSignup, onToggle }: AuthModeToggleProps) => {
  const toggleText = isSignup ? 'Already have an account?' : 'New to TripVibes?';
  const toggleLink = isSignup ? 'Log in here' : 'Create an account';

  return (
    <div className="mt-8">
      <div className="relative">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-default" />
        </div>
        <div className="relative flex justify-center text-sm font-medium leading-6">
          <span className="bg-surface px-6 text-muted">Or</span>
        </div>
      </div>

      <div className="mt-6 text-center text-sm">
        <p className="text-muted font-medium">
          {toggleText}{' '}
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={onToggle}
            className="hover:underline p-0 h-auto"
          >
            {toggleLink}
          </Button>
        </p>
      </div>
    </div>
  );
};
